var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('basic-dialog',{attrs:{"id":"delete-data-collection-dialog","title":"Confirm Delete","primaryButton":"Confirm","secondaryButton":"Cancel","primaryClick":_vm.confirm,"secondaryClick":_vm.cancel}},[_c('p',{staticClass:"usa-prose mt-3"},[_vm._v("Are you sure you want to delete this data collection?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }